import React, { Component } from 'react'
import { ItemData } from '../apis/item.api'
import ContentAside from '../components/ContentAside'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import ShipOrderCreateForm from '../partials/ShipOrderCreateForm'
import ItemCard from '../components/ItemCard'
import ItemQuantityList from '../partials/ItemQuantityList'

interface Props {}

interface State {
  item: ItemData | null
  quantity: number
}

export default class ShipOrderCreate extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      item: null,
      quantity: 0
    }
    this.handleItemChange = this.handleItemChange.bind(this)
  }

  get aside () {
    const { item, quantity } = this.state
    return item &&
      <div className='flex gap-5 flex-col'>
        <ItemCard
          code={item.code}
          description={item.description}
          cpp={item.cpp}
          qpc={item.qpc} />
        <ItemQuantityList
          heading='Shipping total calculation'
          item={item}
          quantity={quantity} />
      </div>
  }

  handleItemChange (item: ItemData | null) {
    this.setState({ item })
  }

  handleQuantityChange = (quantity: number) => {
    this.setState({ quantity })
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <ShipOrderCreateForm
            onItemChange={this.handleItemChange}
            onQuantityChange={this.handleQuantityChange} />
        </ContentMain>
        <ContentAside layout="oneThird">
          {this.aside}
        </ContentAside>
      </ContentLayout>
    )
  }
}
